var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98713 5.43331H6.01693V9.45499H6.98713V5.43331ZM6.49604 4.6624C6.60251 4.6624 6.701 4.63708 6.7915 4.58645C6.88199 4.53581 6.95519 4.46872 7.01109 4.38517C7.06432 4.29909 7.09094 4.20542 7.09094 4.10415C7.09094 4.00035 7.06432 3.90667 7.01109 3.82312C6.95785 3.73705 6.88599 3.66995 6.79549 3.62185C6.70233 3.57122 6.60251 3.5459 6.49604 3.5459C6.39223 3.5459 6.29508 3.57122 6.20458 3.62185C6.11408 3.66995 6.04221 3.73705 5.98898 3.82312C5.93574 3.90667 5.90912 4.00035 5.90912 4.10415C5.90912 4.20542 5.93574 4.29909 5.98898 4.38517C6.04221 4.46872 6.11408 4.53581 6.20458 4.58645C6.29508 4.63708 6.39223 4.6624 6.49604 4.6624Z",
    fill: "#979797"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    stroke: "#979797"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.02916fb1.svg";
export { ForwardRef as ReactComponent };